import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		intro: {
			color: theme.palette.text.secondary,
			marginBottom: 8,
		},
		sectionTitle: {
			fontWeight: "bold",
			fontSize: 18,
			marginTop: 24,
			marginBottom: 16,
		},
		addForm: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-end",
			gap: 12,
			marginBottom: 24,
		},
		boardInput: {
			minWidth: 220,
		},
		idInput: {
			minWidth: 160,
		},
		addButton: {
			height: 40,
		},
		emptyState: {
			padding: "32px 0",
			textAlign: "center",
		},
	} satisfies Record<string, CSSObject>);
};
